import React from 'react';
import { useLocation } from 'react-router-dom';

function Footer() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  // Function to handle navigation
  const navigateToSection = (sectionId) => {
    if (isHomePage) {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = `/#${sectionId}`;
    }
  };

  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">AuLedger</h3>
            <p className="text-gray-400">
              Track, manage, and analyze your gold collection with ease.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => navigateToSection('features')}
                  className="text-gray-400 hover:text-white"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigateToSection('pricing')}
                  className="text-gray-400 hover:text-white"
                >
                  Pricing
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigateToSection('support')}
                  className="text-gray-400 hover:text-white"
                >
                  Support
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <a href="/privacy" className="text-gray-400 hover:text-white">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms" className="text-gray-400 hover:text-white">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <p className="text-gray-400"><a href="mailto:contact@auledgerapp.com">contact@auledgerapp.com</a></p>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>© {new Date().getFullYear()} AuLedger. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
